import React from 'react'
import Header from './Header'
import Topsection from './Topsection';
import Rightside from './Rightside'
import Ourcourses from './Ourcourses'
import Footer from './Footer'
import Frontpopup_form from './Frontpopup_form';

const Ourcoursespage = () => {
  return (
    <div>
        <Topsection/>
        <Header/>
        <Ourcourses/>
        <Footer/>
        <Rightside/>
        <Frontpopup_form/>
    </div>
  )
}

export default Ourcoursespage